// extracted by mini-css-extract-plugin
export default {"wrapper":"Field_wrapper__yy8xj","label":"Field_label__KRIFg"};